import { useMemoAsync } from "@opendash/core";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect } from "react";
import { SaveTicketValues, TicketData } from "../..";
import { Async } from "../../../../_shared";
import { Ticket_FormConfig } from "../../../../js/parsegenerated/Ticket_FormConfig";
import { SaveConfigProvider } from "../context/SaveConfigContext";
import { TicketSaveFormInstanceProvider } from "../context/TicketSaveFormInstanceContext";
import { useSaveTicketForm } from "../hooks/useSaveTicketForm";
import { SaveConfigManager } from "../states/SaveConfigManager";
import { SaveTicketValuesWithFullMeta } from "../types/SaveTicketValues";
import { TicketFormView } from "./TicketFormView";

type Props = {
  initialValues?: SaveTicketValues;
  beforeSave?: (
    values: SaveTicketValuesWithFullMeta
  ) => Async<SaveTicketValuesWithFullMeta>;
  onSaveSuccess?: (
    response: TicketData,
    values: SaveTicketValuesWithFullMeta
  ) => Async<void>;
  onSaveError?: (error: any) => Async<void>;
  overrideSave?: (values: SaveTicketValues) => Async<SaveTicketValues | void>;
};

export const TicketSaveForm = observer((props: Props) => {
  const [form] = Form.useForm<SaveTicketValues>();
  const saveConfigManager = useMemoAsync(
    async () =>
      new SaveConfigManager(await new Parse.Query(Ticket_FormConfig).first()),
    []
  );
  const { onSave } = useSaveTicketForm(props);

  // reapply initial values when they change
  useEffect(() => {
    if (form) form.resetFields();
  }, [form, props.initialValues]);

  useEffect(() => {
    if (!saveConfigManager) return;
    if (saveConfigManager.preparationsComplete) {
      form.resetFields();
      form.setFieldsValue(props.initialValues);
    }
  }, [saveConfigManager, saveConfigManager?.preparationsComplete]);

  if (!saveConfigManager) return <></>;

  return (
    <SaveConfigProvider value={saveConfigManager}>
      <Form<SaveTicketValues>
        form={form}
        layout="vertical"
        onFinish={props.overrideSave ?? onSave}
        initialValues={props.initialValues}
      >
        <TicketSaveFormInstanceProvider value={form}>
          <Form.Item<SaveTicketValues> name="existingTicketId" noStyle>
            <Input type="hidden" disabled />
          </Form.Item>
          <TicketFormView />
        </TicketSaveFormInstanceProvider>
      </Form>
    </SaveConfigProvider>
  );
});
